// CATF Design System Global Theme
export const theme = {
  colors: {
    primary: '#002169',      // Dark Blue
    secondary: '#C22A90',    // Pink/Magenta
    tertiary: '#88B7E9',     // Light Blue
    steel: '#868D96',        // Steel
    grey: '#707070',         // Grey
    white: '#FFFFFF',        // White
    background: '#eaeaea',   // Light grey background
    text: '#707070',         // Default text color
    textDark: '#474747',     // Darker text
    textPrimary: '#212529',  // Primary text (headers) - matches matdb4fusion header style
    success: '#28a745',      // Success green
    error: '#dc3545',        // Error red
    border: '#ddd',          // Default border
  },
  
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: {
      body: '16px',
      small: '12px',
      h1: '40px',
      h2: '30px',
      h3: '24px',
      h4: '20px',
    },
    fontWeight: {
      normal: '400',
      bold: '700',
    },
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  borderRadius: {
    small: '4px',
    medium: '6px',
    large: '10px',
    xlarge: '12px',
  },
  
  shadows: {
    card: '0.2rem 0.2rem 0.3rem rgba(111, 111, 111, 0.4)',
    light: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.15)',
  },
  
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  }
};

export default theme;
